// 联系方式、友情链接

/**
 * @description [联系方式、友情链接](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/ContactController/list)
 */
export const getContactList = () => service.get<Res<Contact.LinkListVO>>('/contact/list')

/**
 * @description [获取小程序内容开关](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/ContactController/getContentSwitch)
 */
export const getContactGetContentSwitch = () => service.get<Res<Contact.ContentSwitchVO>>('/contact/getContentSwitch')
